<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title> Health Issues </mat-panel-title>
    <mat-panel-description>
      <!-- <img [src]="personal" /> -->
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="spinner" *ngIf="healthIssues === undefined">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
  <div class="expansion-content" *ngIf="healthIssues !== undefined">
    <div class="cell">
      <label>Daily Activity : </label>
      <span>{{ healthIssues.dailyActivity }}</span>
    </div>
    <div class="cell">
      <label>Diet Habits : </label>
      <span>{{ healthIssues.dietHabits }}</span>
    </div>
    <div class="cell">
      <label>Preferred Meals: </label>
      <span>{{ healthIssues.mealPrefer }}</span>
    </div>
    <div class="cell">
      <label>Preferred Cuisines : </label>
      <span>{{ healthIssues.cuisinesPrefer }}</span>
    </div>
    <div class="cell">
      <label>Medical Condition : </label>
      <span>{{ healthIssues.medicalCondition }}</span>
    </div>
    <div class="cell">
      <label>Medical History : </label>
      <span>{{ healthIssues.medicalHistory }}</span>
    </div>
    <div class="cell">
      <label>Medical Reports : </label>
      <span>{{ healthIssues.medicalReports }}</span>
    </div>
    <div class="cell">
      <label>Medication : </label>
      <span>{{ healthIssues.aboutMedication }}</span>
    </div>
  </div>
</mat-expansion-panel>
